export enum FilterCountFilterType {
    Category = "Category",
    Classification = "Classification",
    Audience = "Audience",
    CopyrightStatus = "CopyrightStatus",
    DocumentType = "DocumentType",
    DisseminationControl = "DisseminationControl",
    PublicationStatus = "PublicationStatus",
    Sci = "Sci"
}